import { useEffect } from "react";

export default function Redirect({ to }) {
    useEffect(() => {
        // Immediate hard navigation to the external URL
        window.location.replace(to);
    }, [to]);

    return (
        <div
            style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2rem",
                textAlign: "center",
                color: "#5c5450",
                fontFamily: "'Cormorant Garamond', serif",
            }}
            data-testid="redirect-notice"
        >
            <p style={{ fontSize: "1.15rem", fontStyle: "italic" }}>
                Redirigiendo… si no ocurre automáticamente,{" "}
                <a
                    href={to}
                    style={{
                        color: "#b7677a",
                        textDecoration: "underline",
                    }}
                >
                    pulsa aquí
                </a>
                .
            </p>
        </div>
    );
}
